import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentMethod } from '../../models/payment-method.model';
import { AvailablePaymentMethodModel } from '../../models/available-payment-method.model';
import { CURRENT_THEME_HOLDER } from '../../../themes';
import { AvailableBillGatewayAppsModel } from '../../models/available-bill-gateway-apps.model';
import { PaymentMethodFormControl } from '../../forms/payment-method.control';

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent {
  PaymentMethod = PaymentMethod;
  CURRENT_THEME_HOLDER = CURRENT_THEME_HOLDER;

  @Input() availablePaymentMethods: AvailablePaymentMethodModel[];
  @Input() availableBillGatewayApps: AvailableBillGatewayAppsModel[];
  @Input() email: string = null;
  @Input() totalAmount = 0;
  @Input() paymentMethodControl: PaymentMethodFormControl;
  @Input() noCommissionLabelEnabled: boolean;
  @Output() appHover = new EventEmitter<boolean>();

  constructor() {}

  setPaymentMethod(method: PaymentMethod) {
    this.paymentMethodControl.setValue(method);
  }
}
